<template>
  <div class="badge">
    <span>
      <slot /></span>
  </div>
</template>

<script>
export default {
  name: "base-badge"
};
</script>


// WEBPACK FOOTER //
// src/components/base-components/base-badge.vue